export default "__VITE_ASSET__BKRor6k3__"